export default {
  attribute: null,
  attributes: null,
};
